import * as React from 'react';

const QuestionIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
        >
            <circle cx="8" cy="8" r="8" fill="#595959"></circle>
            <path
                fill="#fff"
                d="M10.222 6.333a2.333 2.333 0 00-4.355-1.166.667.667 0 101.155.666 1.002 1.002 0 011.867.5 1 1 0 01-1 1h-.002a.633.633 0 00-.127.026.687.687 0 00-.132.027.655.655 0 00-.103.07.672.672 0 00-.108.073.67.67 0 00-.078.116.652.652 0 00-.065.096.683.683 0 00-.029.142.632.632 0 00-.023.117v.667l.001.007v.327a.667.667 0 00.667.666h.002a.667.667 0 00.665-.668l-.001-.442a2.33 2.33 0 001.666-2.224zM7.42 10.86a.667.667 0 10.94.947.677.677 0 000-.947.69.69 0 00-.94 0z"
            ></path>
        </svg>
    );
};

export default QuestionIcon;
